export const FIT_GRADE_UNIT = '적합도'

export const FIT_GRADE_UNKNOWN = '확인 필요'
